import { DEFAULT_PRODUCT_PACKAGES } from '@/data/templates/quotes/defaultQuoteTemplates';
import type { ProductPackage } from '@/pages/sidebar/SettingsPage/types';

const STORAGE_KEY = 'drahft_product_packages';

export const loadProductPackages = (): ProductPackage[] => {
  if (typeof window === 'undefined') {
    return DEFAULT_PRODUCT_PACKAGES;
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_PRODUCT_PACKAGES;

    const parsed = JSON.parse(raw) as ProductPackage[];
    if (!Array.isArray(parsed)) return DEFAULT_PRODUCT_PACKAGES;

    return parsed.filter(
      item =>
        item &&
        typeof item.id === 'string' &&
        typeof item.name === 'string' &&
        typeof item.description === 'string' &&
        typeof item.price === 'number'
    );
  } catch {
    return DEFAULT_PRODUCT_PACKAGES;
  }
};

export const saveProductPackages = (packages: ProductPackage[]) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(packages));
};
